import React, { FC, useState } from 'react';
import { CreateScheduleResponseDto } from '../../resources/dtos';
import { UserModel } from '../../resources/models';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { LoadingSpinner } from '../../components';

export interface DoctorConsultationCalendlyProps {
  user: UserModel;
  onClose(result?: CreateScheduleResponseDto): void;
}

export const DoctorConsultationCalendly: FC<DoctorConsultationCalendlyProps> = ({ user, onClose }) => {
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  const [isLoading, setIsLoading] = useState(true);

  useCalendlyEventListener({
    onProfilePageViewed: () => {
      setIsLoading(false);
    },
    onDateAndTimeSelected: () => {},
    onEventTypeViewed: () => {
      setIsLoading(false);
    },
    onEventScheduled: (e) => {},
    onPageHeightResize: (e) => {},
  });

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex h-full items-center justify-center bg-popup">
          <LoadingSpinner size="md" />
        </div>
      )}

      <InlineWidget
        url={`https://calendly.com/physioscan/online-sprechstunde?month=${year}-${month}`}
        prefill={{
          name: user.name,
          email: user.email,
          smsReminderNumber: user.phoneNumber,
        }}
        pageSettings={{
          hideEventTypeDetails: true,
          hideLandingPageDetails: true,
        }}
      />
    </div>
  );
};
